import { render, staticRenderFns } from "./TripsHistoryTable.vue?vue&type=template&id=f2a4d58e&scoped=true"
import script from "./TripsHistoryTable.vue?vue&type=script&lang=js"
export * from "./TripsHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./TripsHistoryTable.vue?vue&type=style&index=0&id=f2a4d58e&prod&lang=scss"
import style1 from "./TripsHistoryTable.vue?vue&type=style&index=1&id=f2a4d58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a4d58e",
  null
  
)

export default component.exports